import $ from 'jquery'

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.wt-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight


  var documentHeight = window.Height;

  document.body.style.setProperty('--document-height', `${documentHeight}px`);



  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)

}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)


document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll('.accordion-item');
  if(accordionItems) {

    accordionItems.forEach(function(item) {
      var collapseElement = item.querySelector('.accordion-collapse');

      collapseElement.addEventListener('show.bs.collapse', function() {
        item.classList.add('active');
      });

      collapseElement.addEventListener('hide.bs.collapse', function() {
        item.classList.remove('active');
      });
    });
  }
});

if (window.innerWidth < 996) {
  document.querySelectorAll(".site-footer .footer-menu h2").forEach(function(header) {
    header.addEventListener("click", function() {
      header.classList.toggle("active");
      var nextUl = header.nextElementSibling.querySelector("ul");
      if (nextUl) {
        nextUl.classList.toggle("active");
      }
    });
  });
}



document.addEventListener('DOMContentLoaded', function() {
  var discoverElement = document.querySelector('.discover');

  if (discoverElement) {
    discoverElement.addEventListener('click', function(event) {
      event.preventDefault();
      var entryContent = document.querySelector('.entry-content');
      if (entryContent) {
        entryContent.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});


document.querySelector(".hamburger").addEventListener("click", function(e) {
  if (window.innerWidth < 996) {
    e.preventDefault();
    document.documentElement.classList.add("with-panel-left-reveal");
    document.body.classList.add("left-panel-active");
  }
});

document.querySelectorAll(".panel-overlay, .close-panel").forEach(function(element) {
  element.addEventListener("click", function() {
    document.documentElement.classList.remove("with-panel-left-reveal");
    setTimeout(function() {
      document.body.classList.remove("left-panel-active");
    }, 400);
  });
});




$(document).ready(function() {
  $('.material-field-input').each(function() {
    if ($(this).val()) {
      $(this).addClass('active');
    }
  });

  $('.material-field-input').on('focus blur input', function() {
    if ($(this).val() || $(this).is(':focus')) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });
});
